/*******************************************************
REMOVE COURT ON/OFF PLAYER
Used on the five man stats page for NBA.
********************************************************/

export default async function openCourtOnOffModal(event) {
    const $button = $(event.currentTarget);
    const $player = $button.parents('.court-on-off-player');
    const $modalButton = $player.siblings('.open-court-on-off-modal');

    // Remove the player
    $player.remove();

    // If the Add Player modal button is hidden show it
    if($modalButton.hasClass('hide')){
        $modalButton.removeClass('hide');
    }

}
